module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "info"
  }, [_c('p', [_c('span', [_vm._v("申请日期：")]), _vm._v(" " + _vm._s(_vm.formatTime(_vm.fillingDetails.startDate)))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("备案进度：")]), _vm._v(" " + _vm._s(_vm.fillingDetails.step))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("处理机构：")]), _vm._v(" " + _vm._s(_vm.dealOrg))])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.brank
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticClass: "progress-list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "日期",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatTime(scope.row.endDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "step",
      "label": "事项",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orgName",
      "label": "机构",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creatorName",
      "label": "处理人",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creator",
      "label": "联系方式",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.hidePhone(scope.row.creator)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "opinion",
      "label": "结果",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注说明",
      "min-width": "200"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b708a20","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/weather/fillingProgress.vue
// module id = 1222
// module chunks = 2